import sucursalChildRoutes from './sucursal/routes'

export default [
  {
    path: 'sucursal/:uuid_sucursal',
    component: () => import('@/views/empresa/sucursales/SucursalEmpresaLayout.vue'),
    children: [
      ...sucursalChildRoutes,
    ],
  },
  {
    path: 'sucursal/:uuid_sucursal/productos/:id_producto_sucursal',
    name: 'empresa.sucursal.productos.item.layout',

    component: () => import('@/views/empresa/sucursales/productos/SucursalProductosItemLayout.vue'),
    meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: true, requireSucursalSeleccionada: true },
    redirect: { name: 'empresa.sucursal.productos.item' }, // 👈 redirección

    children: [

      {
        path: 'edit',
        name: 'empresa.sucursal.productos.item',

        component: () => import('@/views/empresa/sucursales/productos/SucursalProductoUpdate.vue'),
        meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: true, requireSucursalSeleccionada: true }

      },
      {
        path: 'historial',
        name: 'empresa.sucursal.productos.item.historial',
        component: () => import('@/views/empresa/sucursales/productos/stock/views/SucursalProductoHistorial.vue')

      },
      {
        path: 'inventario',
        name: 'empresa.sucursal.productos.item.inventario',
        redirect: { name: 'empresa.sucursal.productos.item.inventario.stock' }, // 👈 redirección

        component: () => import('@/views/empresa/sucursales/productos/stock/views/SucursalProductoStock.vue'),
        children: [
          {
            path: 'stock',
            name: 'empresa.sucursal.productos.item.inventario.stock',
            component: () => import('@/views/empresa/sucursales/productos/stock/views/SucursalProductoStockEdit.vue'),
          },
          {
            path: 'movimientos',
            name: 'empresa.sucursal.productos.item.inventario.movimientos',
            component: () => import('@/views/empresa/sucursales/productos/stock/views/SucursalProductoStockMovimientos.vue'),
          },
        ]


      },

    ]
  },
]